'use strict';

const { h, Component } = require('phy');

const PreactCarousel = require('@grpn/preact-carousel/src/preact-carousel-plain');

const Card = require('../card/card');
const MpuCard = require('../../modules/coupons/views/coupon-advert');
const Thumbnail = require('./thumbnail');
const Legal = require('../../modules/coupons/views/legal');
const CouponButton = require('../../modules/coupons/views/coupon-button');

const { getOfferImageSize, getLogoImageSize } = require('../card/card');

function shouldBeLazy(index, items) {
  return index > 1 && index < items.length - 1;
}

function getCards({ items, routes, isTouch, cardWidth }) {
  return items.map((item, index) => {
    const elements = [
      Card({
        routes,
        item,
        sizes: {
          offer: getOfferImageSize(isTouch, cardWidth),
          logo: getLogoImageSize(isTouch),
        },
        className: 'carousel-card',
        lazy: shouldBeLazy(index, items),
      }),
      isTouch && Legal({ item, routes }),
    ];

    if (item.offerId) {
      elements.push(
        h(CouponButton, {
          coupon: { offerType: item.offerType, offerId: item.offerId },
          className: 'coupon-background',
        })
      );
    }

    return h('.content', elements);
  });
}

function getMpuCards(items, routes) {
  return items.map((item, index) =>
    h(
      '.carousel-slide',
      MpuCard({
        routes,
        coupon: item,
        lazy: shouldBeLazy(index, items),
      })
    )
  );
}

function getPagesItems(items, selectedIndex) {
  const limit = 3;
  if (selectedIndex + limit > items.length) {
    return [
      ...items.slice(selectedIndex),
      ...items.slice(0, selectedIndex - items.length + limit),
    ];
  }

  return items.slice(selectedIndex, selectedIndex + limit);
}

class Carousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardWidth: 0,
      thumbnails: [],
      legal: null,
    };

    this.carouselReference;
    this.isVerticalTransitionEnabled =
      !this.props.isTouch && this.props.containsOffers;

    this.setThumbnails = this.setThumbnails.bind(this);
    this.setLegal = this.setLegal.bind(this);
    this.onWindowResize = this.onWindowResize.bind(this);
  }

  componentDidMount() {
    if (this.isVerticalTransitionEnabled) {
      this.setThumbnails(0);
      this.setLegal(0);
    }

    this.onWindowResize();

    window.addEventListener('resize', this.onWindowResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onWindowResize);
  }

  componentDidUpdate() {
    window.Groupon.Utils.lazyLoadImages();
  }

  onWindowResize() {
    const offerImage =
      document.querySelector('.logo') ||
      document.querySelector('.coupon-advert-image');

    if (offerImage) {
      this.setState({ cardWidth: offerImage.offsetWidth });
    }
  }

  setThumbnails(activeIndex) {
    const { items, routes } = this.props;

    const itemsAdjusted = getPagesItems(items, activeIndex);

    const thumbnails = itemsAdjusted.map((item, index) =>
      Thumbnail({
        item,
        index,
        clickNavigation: this.carouselReference.clickNavigation,
        routes,
      })
    );

    this.setState({ thumbnails });
  }

  setLegal(activeIndex) {
    const { items, routes } = this.props;

    const item = items[activeIndex];

    this.setState({ legal: Legal({ item, routes }) });
  }

  render() {
    const {
      items,
      isTouch,
      routes,
      className = 'carousel-sidebar',
      containsOffers,
    } = this.props;
    const { cardWidth } = this.state;

    if ((className === 'carousel-sidebar' && isTouch) || !items.length) {
      return null;
    }

    const cards = containsOffers
      ? getCards({ items, routes, isTouch, cardWidth })
      : getMpuCards(items, routes);

    return h(
      '',
      { 'data-bhw': 'CouponsCarousel', className },
      h(
        PreactCarousel,
        {
          isTouch,
          ref: carousel => {
            this.carouselReference = carousel;
          },
          thumbnails: this.state.thumbnails,
          legal: this.state.legal,
          updateOuterElements: activeIndex => {
            this.setThumbnails(activeIndex);
            this.setLegal(activeIndex);
          },
          isVerticalTransitionEnabled: this.isVerticalTransitionEnabled,
        },
        cards
      )
    );
  }
}

module.exports = Carousel;
